export const useIntercom = () => {
  function showNewMessage (message) {
    if (window?.Intercom) {
      window.Intercom('showNewMessage', message)
    }
  }

  return {
    showNewMessage
  }
}
